import { HttpError } from '@/shared/utils/requestUtils'

const portalSessionDeadEventName = 'portal-session-dead'

export const publishPortalSessionDead = (): void => {
    if (typeof window === 'undefined') return
    window.dispatchEvent(new Event(portalSessionDeadEventName))
}

export const publishPortalSessionDeadOnUnauthorized = (error: unknown): void => {
    if (error instanceof HttpError && error.status === 401) {
        publishPortalSessionDead()
    }
}

export const subscribePortalSessionDead = (onSessionDead: () => void): (() => void) => {
    if (typeof window === 'undefined') return () => undefined
    window.addEventListener(portalSessionDeadEventName, onSessionDead)
    return () => window.removeEventListener(portalSessionDeadEventName, onSessionDead)
}
